<template>
  <div class="sign_in wrapper">
    <section class="grid-content">
      <div class="contenedor">
        <form @submit.prevent="sendEmail()">
          <div class="form-group">
            <label for="exampleInputEmail1">
               <p>{{ $t('passwordForgotEmail') }}</p>
               <p>{{ $t('passwordForgotEmail2') }}</p>
            </label>
            <input
              v-model="email"
              type="email"
              class="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              :placeholder="$t('sessionEmailPlaceholder')"
            >
          </div>
          <div class="forgot-button">                                 
            <button type="submit" class="btn signup--btn">{{ $t('passwordForgotSendButton') }}</button>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
  import i18n from '@/plugins/i18n';

  export default {
    data() {
      return {
        language : localStorage.setItem("language"),
        image:"en",
        email:"",
        languages: [{ 
                      flag: 'us', 
                      language: 'en', 
                      title: 'English' 
                    },
                    { flag: 'es', 
                      language: 'es', 
                      title: 'Español' },
                    { flag: 'de',
                      language: 'de',
                      title: 'Deutsch'}]
      };
    },
    methods: {
      sendEmail (event) {
        //Si no hay email
        if(!this.email){
           this.$toastr.e("Type an email");
        }else{
            console.log(`Enviamos email a la dirección facilitada ${this.email}`);
            console.lo
            if(this.language){
              const passGenerated = this.randomPassword();
              console.log(`Con la pasw ${passGenerated}`);
              this.axios.post('https://lightkey.es:3000/lightime/api/owner/email',{email:this.email,password:passGenerated,language:this.language})
              .then(response => {
                console.log(response.data);
                if(response.data==this.email){
                    this.$toastr.s("Email enviado");
                    this.$router.replace('/');
                }else{
                    this.$toastr.e("Email no existe");
                }              
              })
              .catch(err => {
                console.log("Algo pasa!");                
                console.log("Login erroneo", err);
                this.$toastr.e("Email no enviado");
              });
            }else{
              console.log("No hay lenguaje seleccionado");
            }  
        }       
      },
      randomPassword() {
         var chars =
         "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
         var pass = "";
         for (var x = 0; x < 10; x++) {
         var i = Math.floor(Math.random() * chars.length);
         pass += chars.charAt(i);
         }
         return pass;
      }
    },
    created(){
      this.language=localStorage.getItem("language");
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.contenedor {
  padding: 10% 30px;
  border: 2px solid #4cae4c;
  border-radius: 20px;
}

.logo {
  margin-right: 38px;
  padding: 40px;
}

.logo-img {
  max-width: 200px;
}

.logo-text {
  max-width: 150px;
}

h1 {
  color: #7ab648;
}

.forgot--btn {
  text-decoration: none;
  color: #353d46;
  display:flex;
}
.forgot--btn:hover {
  color: #7ab648;
}


a.signup--btn  {
  color:white;
}

.btn {
  background-color: #5cb85c;
  color: white;
  border: 1px solid #4cae4c;
}

.wrapper {
  margin-top: 10%;
  display: grid;
  grid-template-columns: 1fr minmax(200px, 700px) 1fr;
}

@media only screen and (max-width: 430px) {
  .wrapper {
    /* padding: 50px auto; */
    display: grid;
    grid-template-columns: 1fr minmax(200px, 300px) 1fr;
  }
}

.grid-content {
  grid-column: 2/3;
}

.forgot-button {
  float:right;
}

.footer{
  margin-top: 10%;
}
.footer-img{
  width: 300px;
  height: 60px;
}
</style>


// WEBPACK FOOTER //
// src/components/utilities/Forgot.vue